
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import DefaultLayout from '@/components/DefaultLayout.vue';
@Component({
  components: { DefaultLayout }
})
export default class JsonToCsv extends Vue {
  refs!: {
    DefaultActions: HTMLFormElement;
  };
  /* Properties */
  /* Store Actions */
  /* Watchers */
  /* Data */
  rawText: string = '';
  /* Async Functions */
  /* Utility Functions */
  getRelevantValues() {
    const rows: string[][] = [];
    for (let card of this.Json.cards) {
      rows.push(['Task', card.name]);
    }
    console.log(rows);
    let csvContent =
      'data:text/csv;charset=utf-8,' + rows.map(e => e.join(',')).join('\n');
    var encodedUri = encodeURI(csvContent);
    console.log(encodedUri);
    var link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'my_data.csv');
    document.body.appendChild(link); // Required for FF

    link.click();
  }
  /* Loaders */
  /* Mounted */
  /* Created */
  /* Emmited Functions */
  /* Computed */
  get Json() {
    if (this.rawText) {
      let formattedText = this.rawText
        .replace(/(\r\n|\n|\r|)/gm, '')
        .replace(/ +(?= )/g, '');
      return JSON.parse(formattedText);
    }
    return '';
  }
}
